var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoginSignupComboForm',{attrs:{"longform":true,"titleAlignment":"left","enableBack":true,"backAction":_vm.back},on:{"success":_vm.next}})}
var staticRenderFns = []

export { render, staticRenderFns }